import { FunctionComponent, useEffect, useState } from "react";

export interface ICoomingSoon {}

const CoomingSoon: FunctionComponent<ICoomingSoon> = () => {
  const [visible, setVisible] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const [dotsVisible, setDotsVisible] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 100);
    const t2 = setTimeout(() => setTextVisible(true), 700);
    const t3 = setTimeout(() => setDotsVisible(true), 1400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-gray-950 overflow-hidden">

      {/* Animated background rings */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] rounded-full border border-white/5 animate-ping" style={{ animationDuration: "3s" }} />
        <div className="absolute w-[400px] h-[400px] rounded-full border border-white/10 animate-ping" style={{ animationDuration: "2.5s", animationDelay: "0.5s" }} />
        <div className="absolute w-[220px] h-[220px] rounded-full border border-white/15 animate-ping" style={{ animationDuration: "2s", animationDelay: "1s" }} />
      </div>

      {/* Glowing background blob */}
      <div className="absolute w-96 h-96 bg-green-600/20 rounded-full blur-3xl animate-pulse" style={{ animationDuration: "4s" }} />

      {/* Logo */}
      <div
        className="relative z-10 flex flex-col items-center gap-8"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(30px)",
          transition: "opacity 0.8s ease, transform 0.8s ease",
        }}
      >
        <img
          src="/logo.png"
          alt="TRU Logo"
          className="w-40 md:w-56 drop-shadow-2xl"
      
        />

        {/* Coming Soon text */}
        <div
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.8s ease, transform 0.8s ease",
          }}
        >
          <h1 className="text-white text-4xl md:text-5xl font-bold tracking-widest uppercase text-center">
            Coming Soon
          </h1>
        </div>

        {/* Animated dots */}
        <div
          className="flex gap-3 mt-2"
          style={{
            opacity: dotsVisible ? 1 : 0,
            transition: "opacity 0.8s ease",
          }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-3 h-3 rounded-full bg-green-500"
              style={{
                display: "inline-block",
                animation: "bounce 1.2s infinite",
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>

        {/* Subtitle */}
        <p
          className="text-gray-400 text-sm md:text-base tracking-widest text-center px-4"
          style={{
            opacity: dotsVisible ? 1 : 0,
            transition: "opacity 1s ease 0.3s",
          }}
        >
          We are working on something great. Stay tuned.
        </p>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
          40% { transform: translateY(-10px); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default CoomingSoon;
